<template>
        <v-app-bar color="#AB0520">
        <!-- <template v-slot:prepend> 
          <v-app-bar-nav-icon></v-app-bar-nav-icon>
        </template> -->
        <!-- <a
        href="https://www.arizona.edu"
        title="The University of Arizona homepage"
        class="arizona-logo remove-external-link-icon"
        target="_blank"
        rel="noopener noreferrer">
        <img alt="The University of Arizona Wordmark Line Logo White" width="45"  src="https://brand.arizona.edu/sites/default/files/imported/ua_block_rgb_4.svg" class="mx-2 mt-2">
      </a>       -->

        <v-app-bar-title class="text-left font-weight-bold text-h5" >Shared Churches</v-app-bar-title>

        <v-spacer></v-spacer>

       
            

        <!-- <template v-slot:append>
          <v-btn icon="mdi-dots-vertical"></v-btn>
        </template> -->

      </v-app-bar>      

  </template>       

<style scoped>
.arizona-line-logo {
  top: 22px;
  position: absolute;
  height: 21px;
}
</style>